import { render, staticRenderFns } from "./Verify-Email-Note.vue?vue&type=template&id=0f72f938&scoped=true&"
import script from "./Verify-Email-Note.vue?vue&type=script&lang=js&"
export * from "./Verify-Email-Note.vue?vue&type=script&lang=js&"
import style0 from "./Verify-Email-Note.vue?vue&type=style&index=0&id=0f72f938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f72f938",
  null
  
)

export default component.exports